import CONSTANTS from '../../constants';

export function checkins(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.CHECKIN.GET.CHECKINS:
            return action.checkins;
        default:
            return state
    }
}
